import { render, staticRenderFns } from "./AddProductType.vue?vue&type=template&id=e5a0424a"
import script from "./AddProductType.vue?vue&type=script&lang=js"
export * from "./AddProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports